import styled from 'styled-components';
import {
  Body2,
  borderWidth1,
  borderColors,
  borderRadius,
  colors,
  fontWeights,
  spacing,
} from 'ui/theme';
import { Select } from 'ui/selectv2/Select';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  border: ${borderWidth1} ${borderColors.borderPrimary};
  border-radius: ${borderRadius.md};
  margin-bottom: ${spacing.base};
`;

export const Left = styled.div`
  background-color: ${colors.backgroundSecondary};
  border-right: ${borderWidth1} ${borderColors.borderPrimary};
  padding: ${spacing.base};
  &:not(:first-child) {
    border-top: ${borderWidth1} ${borderColors.borderPrimarySubtle};
  }
`;

export const Body2Bold = styled(Body2)`
  font-weight: ${fontWeights.bold};
`;

export const Right = styled.div`
  padding: ${spacing.base};
  &:not(:nth-child(2)) {
    border-top: ${borderWidth1} ${borderColors.borderPrimary};
  }
`;

export const FlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

export const SelectFixedWidth = styled(Select)`
  width: 200px;
`;

export const ComboButton = styled.div`
  display: flex;
  > *:not(:only-child) {
    &:first-child {
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }
    &:last-child button {
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }
  }
`;
